import { unwrap, type components } from "@wilco/api";
import { api } from "../auth.ts";

/*
 * Справочник товаров и контрагенты: клиент из contracts/openapi.json
 * (модули catalog и partners, PR #54). Типы сгенерированы, ошибки
 * problem+json с кодом и аргументами для текста из errors.properties.
 */
type S = components["schemas"];
export type Product = S["CatalogProduct"];
export type Match = S["CatalogMatch"];
export type TemplateCard = S["CatalogTemplateCard"];
export type Offer = S["CatalogOffer"];
export type OfferInput = S["CatalogOfferInput"];
export type Category = S["CatalogCategory"];
export type ProductInput = S["CatalogProductInput"];
export type TemplateEdit = S["CatalogTemplateEdit"];
export type Partner = S["PartnerCard"];
export type PartnerInput = S["PartnerInput"];
export type PartnerSaved = S["PartnerSaved"];

const id = (v: string) => ({ params: { path: { id: v } } });

/**
 * Название варианта без артикула: displayName сервера уже «[MOT-0001] Мотор»,
 * а экран показывает артикул отдельно, моноширинным.
 */
export const variantName = (p: Product): string => (p.version ? `${p.name} (${p.version})` : p.name);

export const catalogApi = {
  search: (q: string, limit = 20) => unwrap(api.GET("/api/v1/catalog/products/search", { params: { query: { q, limit } } })),
  product: (v: string) => unwrap(api.GET("/api/v1/catalog/products/{id}", id(v))),
  setCode: (v: string, code: string) => unwrap(api.PUT("/api/v1/catalog/products/{id}/code", { ...id(v), body: { code } })),
  addOffer: (productId: string, body: OfferInput) => unwrap(api.POST("/api/v1/catalog/products/{id}/offers", { ...id(productId), body })),
  categories: () => unwrap(api.GET("/api/v1/catalog/categories")),
  template: (v: string) => unwrap(api.GET("/api/v1/catalog/templates/{id}", id(v))),
  createTemplate: (body: ProductInput) => unwrap(api.POST("/api/v1/catalog/templates", { body })),
  editTemplate: (v: string, body: TemplateEdit) => unwrap(api.PATCH("/api/v1/catalog/templates/{id}", { ...id(v), body })),
  archive: (v: string) => unwrap(api.POST("/api/v1/catalog/templates/{id}/archive", id(v))),
  restore: (v: string) => unwrap(api.POST("/api/v1/catalog/templates/{id}/restore", id(v))),
  duplicate: (v: string) => unwrap(api.POST("/api/v1/catalog/templates/{id}/duplicate", id(v))),
  addVersion: (v: string, name: string, code: string | null) =>
    unwrap(api.POST("/api/v1/catalog/templates/{id}/versions", { ...id(v), body: { name, code } })),
  archiveVersion: (v: string, version: string) =>
    unwrap(api.POST("/api/v1/catalog/templates/{id}/versions/{version}/archive", { params: { path: { id: v, version } } })),

  partners: (q: string, limit = 50) => unwrap(api.GET("/api/v1/partners", { params: { query: { q, limit } } })),
  partner: (v: string) => unwrap(api.GET("/api/v1/partners/{id}", id(v))),
  createPartner: (body: PartnerInput) => unwrap(api.POST("/api/v1/partners", { body })),
  savePartner: (v: string, body: PartnerInput) => unwrap(api.PUT("/api/v1/partners/{id}", { ...id(v), body })),
  archivePartner: (v: string) => unwrap(api.POST("/api/v1/partners/{id}/archive", id(v))),
  restorePartner: (v: string) => unwrap(api.POST("/api/v1/partners/{id}/restore", id(v))),
};
